<template>
    <div class="fileList documentation__fileList">
        <div v-if="documents.length">
            <cad-construction-list :documents="documents" :type="type"/>
        </div>
        <div v-if="!processing && documents.length === 0 && getLastSlug() && !hasChildren()">
            Je nám líto, tato kategorie neobsahuje žádné odkazy
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapState} from 'vuex';
    import filter from 'lodash/filter';
    import isUndefined from 'lodash/isUndefined';
    import last from 'lodash/last';
    import first from 'lodash/first';
    import {SLUG_SEPARATOR} from './const';
    import DownloadDocumentList from "./DocumentList";
    import CadConstructionList from "../cad/ConstructionList";

    export default {
        name: 'DownloadMainList',
        components: {CadConstructionList, DownloadDocumentList},
        computed: {
            ...mapGetters('cad', ['documents', 'categories', 'type', '']),
            ...mapState('cad', {
                processing: state => state.documents.processing
            })
        },
        watch: {
            '$route': function () {
                this.loadDocuments();
            },
        },
        mounted() {
            this.loadDocuments();
        },
        methods: {
            ...mapActions('cad', ['fetchDocuments']),
            loadDocuments() {
                this.fetchDocuments(this.getCategoryBySlug());
            },
            getLastSlug() {
                const {slug} = this.$route.params;
                if (isUndefined(slug)) {
                    return null;
                }
                return last(slug.split(SLUG_SEPARATOR));
            },
            getCategoryBySlug() {
                const slug = this.getLastSlug();
                if (slug) {
                    const category = first(filter(this.categories, category => category.slug === slug));
                    if (!isUndefined(category)) {
                        return category.id;
                    }
                }
                return null;
            },
            hasChildren() {
                const slug = this.getLastSlug();
                return filter(this.categories, category => category.parentSlug === slug).length;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/MainList.vue